import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const inputAndCustomIndicatorClass =
  'block h-[18px] left-0 mt-[3px] absolute top-0 w-[18px]';

const Radio = ({
  checked,
  children,
  disabled,
  id,
  inline = false,
  name,
  onChange,
  size = 'md',
  value,
}) => (
  <label
    className={classNames(`relative`, {
      'hover:cursor-pointer group': !disabled,
      'Radio--inline inline mb-0': inline,
      'block mb-2': !inline,
    })}
    htmlFor={id}
  >
    <input
      className={classNames(inputAndCustomIndicatorClass, 'opacity-0', {
        peer: !disabled,
      })}
      type="radio"
      checked={checked}
      disabled={disabled}
      id={id}
      name={name}
      value={value}
      onChange={event => {
        if (disabled) {
          // If Radio is disabled, we should not call onChange
          return;
        }

        if (onChange) {
          onChange(event);
        }
      }}
    />

    <span
      className={classNames(
        inputAndCustomIndicatorClass,
        'items-center flex border-[1px] border-gray-light6 justify-center rounded-full',
        {
          'group-hover:border-[1px] group-hover:border-brand peer-focus:border-brand': !disabled,
          "bg-white border-brand before:bg-brand before:rounded-full before:content-[''] before:h-3 before:w-3":
            checked && !disabled,
          'bg-gray-light6': disabled,
        }
      )}
    />
    {children && (
      <span
        className={classNames('text-gray block pl-[30px]', {
          'text-base': size === 'md',
          'text-sm': size === 'sm',
          inline,
        })}
      >
        {children}
      </span>
    )}
  </label>
);

Radio.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  inline: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
  value: PropTypes.string,
};

export default Radio;
